import { useSelector } from "react-redux";
import { State } from "@App/state";
import { selectNetworkId } from "@App/state/selectors/orders";
import { useQuery } from "@apollo/client";
import { GaragePremiumServicesQuery, GET_GARAGE_PREMIUM_SERVICES } from "@App/graphql/queries";
import { useNetwork } from "./useNetwork";

export const usePremiumServices = () => {
  const organization = useSelector((state: State) => state.orders.organization);
  const service = useSelector((state: State) => state.orders.service);
  const garage = useSelector((state: State) => state.orders.garage);
  const driverID = useSelector((state: State) => state.auth?.driverData?.uuid);
  const presetFilters = useSelector((state: State) => state.filters.presetFilters);
  const networkId = useSelector(selectNetworkId);

  const { loading: networkLoading } = useNetwork();

  const { loading, data, error } = useQuery<GaragePremiumServicesQuery>(
    GET_GARAGE_PREMIUM_SERVICES,
    {
      variables: {
        organization: organization ? organization.id : null,
        garage: garage ? garage.id : null,
        services: service ? [service.id] : null,
        driverID: driverID,
        presetFilters: presetFilters,
        network: networkId ?? null,
      },
      fetchPolicy: "no-cache",
      skip: !organization || !garage || networkLoading,
    },
  );

  return {
    loading: loading || networkLoading,
    error: error,
    premiumServices: data ? data.organization?.garages?.data[0]?.premium_services : null,
  };
};
